"use client";

import {styled} from "@mui/material";

const Card = styled("div")(({theme}) => ({
  marginTop: 16,
  padding: 16,
  borderRadius: 8,
  background: "rgba(255, 255, 255, 0.05)",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.3s",
  "&:hover": {
    transform: "translateY(-4px)"
  }
}));

export default Card;
